export default __webpack_public_path__ + "static/greenshield_solution-08e8b8478c98ae6dc8907a33cb6a92a7.png";